var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.componentIs,
    {
      tag: "component",
      attrs: {
        visible: _vm.visible,
        title: _vm.roomId
          ? _vm.$t("pc_biz_edit_live" /* 编辑直播 */)
          : _vm.$t("pc_biz_add_live" /* 添加直播 */),
        "destroy-on-close": true,
        size: "720px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.close,
      },
    },
    [
      _c("LiveForm", {
        ref: "liveForm",
        attrs: {
          fields: _vm.fieldsAll,
          roomId: _vm.roomId,
          liveRoomInfo: _vm.liveRoomInfo,
        },
      }),
      _vm.moreFields.length && !_vm.showMore
        ? _c(
            "div",
            {
              staticClass: "tlive-create__more--config",
              on: { click: _vm.setMoreConfig },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$t("pc_tlive_moreSettings" /* 更多设置 */)) +
                  "\n    "
              ),
              _c("em", { staticClass: "yxt-icon-arrow-down" }),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "tlive-create-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          !_vm.btnOperationHidden.includes("cancel")
            ? _c(
                "yxt-button",
                {
                  attrs: { plain: "" },
                  on: {
                    click: function () {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("pc_biz_live_cancel" /* 取消 */)))]
              )
            : _vm._e(),
          !_vm.btnOperationHidden.includes("save")
            ? _c(
                "yxt-button",
                {
                  attrs: { type: "second", loading: _vm.createLoading },
                  on: {
                    click: function ($event) {
                      return _vm.beforeCreate()
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.roomId
                        ? _vm.$t("pc_biz_live_save" /* 保存 */)
                        : _vm.$t("pc_biz_live_create" /* 创建 */)
                    )
                  ),
                ]
              )
            : _vm._e(),
          !_vm.btnOperationHidden.includes("saveInto")
            ? _c(
                "yxt-button",
                {
                  attrs: { type: "primary", loading: _vm.createIntoLoading },
                  on: {
                    click: function ($event) {
                      return _vm.beforeCreate("into")
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.roomId
                        ? _vm.$t(
                            "pc_biz_live_saveIntoManage" /* 保存并进入管理后台 */
                          )
                        : _vm.$t(
                            "pc_biz_live_crateIntoManage" /* 创建并进入管理后台 */
                          )
                    )
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }